import { Injectable } from '@angular/core';
import { initializeApp,getApps  } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RemoteConfigService {

  private remoteConfig;
 
  constructor() {
    
    const app = !getApps().length
      ? initializeApp(environment.firebase)
      : getApps()[0];

    this.remoteConfig = getRemoteConfig(app);

    this.remoteConfig.settings = {
      minimumFetchIntervalMillis: 0
    };

    this.remoteConfig.defaultConfig = {
      my_json: '{}'
    };
  }

  async loadConfig() {
    await fetchAndActivate(this.remoteConfig);
  }

  getJsonConfig() {
    try {
      const env = !environment.production ? 'dev' : 'prod';

      const value = env === 'dev'
        ? getValue(this.remoteConfig, 'env_web_dev').asString()
        : getValue(this.remoteConfig, 'env_web').asString();
      
      if (!value) {
        console.warn('Remote config is empty');
        return null;
      }

      return JSON.parse(value);

    } catch (e) {
      console.error('Invalid JSON', e);
      return null;
    }
  }
}